import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { DrawingShapeState } from './drawingShape.slice.types';

import { DrawingObject } from '~/core/types/drawingShape';

const initialState: DrawingShapeState = {
  activeDrawingObject: undefined,
  needRedrawCanvas: false,
  preventRepricing: false,
};

const drawingShapeSlice = createSlice({
  name: 'drawingShape',
  initialState,
  reducers: {
    // === start needRedrawCanvas
    updateNeedRedrawCanvas: (state, action: PayloadAction<boolean>) => {
      state.needRedrawCanvas = action.payload;
    },
    // === end needRedrawCanvas
    // === start preventRepricing
    setPreventRepricing: (state, action: PayloadAction<boolean>) => {
      state.preventRepricing = action.payload;
    },
    // === end preventRepricing
    setActiveDrawingObject: (
      state,
      action: PayloadAction<DrawingObject | undefined>
    ) => {
      const previousActiveObject = state.activeDrawingObject?.previousObject;
      const previousObjectIsNotCurrent =
        previousActiveObject?.object?.id !== action.payload?.id;
      const previousObject =
        previousObjectIsNotCurrent && previousActiveObject
          ? previousActiveObject
          : undefined;

      state.activeDrawingObject = {
        object: action.payload,
        previousObject,
      };
    },
    resetActiveDrawingObject: (state) => {
      state.activeDrawingObject = initialState.activeDrawingObject;
    },
  },
});

export const {
  updateNeedRedrawCanvas,
  setPreventRepricing,
  setActiveDrawingObject,
  resetActiveDrawingObject,
} = drawingShapeSlice.actions;

export default drawingShapeSlice.reducer;
